import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

export async function fetchShareholderOwnership() {
  const res = await fetch(`${API_BASE}/api/shareholder/ownership`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات الملكية'));
  return {
    myOwnershipPct: Number(data.myOwnershipPct ?? 0),
    totalShares: Number(data.totalShares ?? 0),
    myShares: Number(data.myShares ?? 0),
    rankAmongShareholders: Number(data.rankAmongShareholders ?? 0),
    shareholdersCount: Number(data.shareholdersCount ?? 0),
    largestShareholderPct: Number(data.largestShareholderPct ?? 0),
    peers: Array.isArray(data.peers) ? data.peers : [],
  };
}
